<div class="col-sm-2 amenities-filter">
    <div class="amenities-filter_view-part" (click)="showDropdown = !showDropdown">Filter</div>
    <spinner [spinnerShow]="propertyService.companies.length < 1"></spinner>
    <div class="amenities-filter_dropdown" [hidden]="!showDropdown">
        <div class="amenities-filter-items-wrapper">
            <div class="m-b-xs filter-checkbox" *ngFor="let company of propertyService.companies; let index = index;">
                <label class="img-checkbox">
                    <input type="checkbox" id="{{company.id}}" [attr.checked]="company.filtered ? '' : null" (change)="timeOutBeforeFilterChanging()">
                    <label for="{{company.id}}"><svg-checked></svg-checked></label>
                    <span>{{company.name}}</span>
                </label>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/properties-filter/properties-filter.component.html